export default __webpack_public_path__ + "img/ba1892a6b74690a6b21dc40e90aaac9a.svg";